export const parseUser = (user) => {
  const {
    sub: id, email: username, name: firstName, family_name: lastName, email,
  } = user;

  return {
    id, username, firstName, lastName, email,
  };
};
